import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left-tail",
  "use": "arrow-left-tail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-left-tail\">\r\n<style type=\"text/css\">\r\n\t#arrow-left-tail .st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n</style>\r\n<path class=\"st0\" d=\"M17.4,11.6l-3.5-3.5l-0.7,0.7l2.6,2.6H7v1h8.8l-2.6,2.6l0.7,0.7l3.5-3.5C17.5,12.2,17.5,11.8,17.4,11.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol